/**
 * Утилита для условного логирования
 * Выводит console.log только в development режиме
 * В production сборке логи не выводятся
 */

export const devLog = (...args: unknown[]): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

export const devWarn = (...args: unknown[]): void => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
};

export const devError = (...args: unknown[]): void => {
  // Error всегда выводим, даже в production
  console.error(...args);
};

export default devLog; 